import React from 'react';
import PropTypes from 'prop-types';

export const allSvgs = (name, fill, className) => ({
  'yellow-triangles': (
    <svg className={className} viewBox="0 0 40 121.98" xmlns="http://www.w3.org/2000/svg">
      <g data-name="Layer 2" id="Layer_2">
        <g id="OBJECTS">
          <polygon fill="#211109" points="40 99.05 0 99.05 20 121.98 40 99.05" />
          <polygon fill="#d6e03e" points="40 48.43 0 48.43 20 71.36 40 48.43" />
          <polygon fill="#d6e03e" points="40 0 0 0 20 22.93 40 0" />
        </g>
      </g>
    </svg>
  ),
  'green-triangles': (
    <svg className={className} viewBox="0 0 101.56 33.3" xmlns="http://www.w3.org/2000/svg">
      <g data-name="Layer 2" id="Layer_2">
        <g id="OBJECTS">
          <polygon fill="#211109" points="19.09 33.3 19.09 0 0 16.65 19.09 33.3" />
          <polygon fill="#00a9a3" points="61.24 33.3 61.24 0 42.15 16.65 61.24 33.3" />
          <polygon fill="#00a9a3" points="101.56 33.3 101.56 0 82.47 16.65 101.56 33.3" />
        </g>
      </g>
    </svg>
  ),
  zigzag: (
    <svg className={className} viewBox="0 0 55.49 10.19" xmlns="http://www.w3.org/2000/svg">
      <g data-name="Layer 2" id="Layer_2">
        <g id="OBJECTS">
          <polyline fill="none" stroke="#00a9a3" strokeMiterlimit="10" points="0.31 8.95 10.68 0.71 18.27 8.95 28.14 0.71 37.77 8.95 46.01 0.71 55.14 9.84" />
        </g>
      </g>
    </svg>
  )
});

const Svg = ({
  name, fill, className, title
}) => allSvgs(name, fill, className, title)[name] || null;

Svg.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  fill: PropTypes.string,
  className: PropTypes.string
};
Svg.defaultProps = {
  fill: '#ffffff',
  className: ''
};

export default Svg;
